(function() {
    'use strict';

    angular
        .module('quantixApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal','AuthTrackerProvider', 'AuthServerProvider', 'Account', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService','$window'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal,AuthTrackerProvider, AuthServerProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService,$window) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            encryptPassword:encryptPassword
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                
                if(isAuthenticated && $sessionStorage.sessionConfrimation==='duplicateLogins' ){
              	   if($rootScope.toState.name != 'sessionConfirmation'){
              		   $state.go('sessionConfirmation');
              	   }
                 }
                
                if(isAuthenticated){
                    Principal.identity().then(function(account){
                       var authorities=account.authorities;
                       if(account.isExternal==='Y')
                       {
                    	   $rootScope.roleuser=true;
                    	   $rootScope.rolecompanyreport=false;
                       }else if(account.isInternal==='Y')
                       {
                    	   if(authorities.indexOf(158)!==-1){
                    		   $rootScope.rolecompanyreport=true;  
                    	   }else{
                    		   $rootScope.rolecompanyreport=false;
                    	   }
                    	   
                           $rootScope.isInternal=true;
                    	   if(authorities.indexOf(1)!==-1){
                               $rootScope.roleuser=false;
                               $rootScope.roleadmin=true;
                               
                           }else if(authorities.indexOf(2)!==-1){
                        	   	$rootScope.roleuser=false;
                           } 
                       }
                    });
                 } else {
                   $rootScope.roleuser=false;
                   $rootScope.roleadmin=false;
                   $rootScope.rolecompanyreport=false;
                   var authnotreqstates=["register","login","smsotpverification","finishReset","activate","feedback","termsofuse"];
                   if(authnotreqstates.indexOf($rootScope.toState.name)==-1){
                      AuthTrackerProvider.logout();
                      Principal.authenticate(null);
                   };
                 }
                
                if($sessionStorage.Loginverification==='true'){
                	logout();
                }
                $rootScope.homePageMenuStatus=true;
                if($rootScope.toState.name=='forbidden' && $window.localStorage.modlength!=0){
                	$rootScope.homePageMenuStatus = false;
                }
                if(isAuthenticated){
                	$rootScope.register=false;
                	$rootScope.activatelink=false;
                	$rootScope.forgotpass=false;


                }else{
                	$rootScope.register=true;
                	$rootScope.activatelink=true;
                	$rootScope.forgotpass=true;

                	//logout();
                }
              // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');

                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            $state.go('login');
                        });
                    }
                }
            }
        }

        function changePassword (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
        function encryptPassword(password) {
        	var iv = "3ad5485e60a4fecde36fa49ff63817dc";
            var key = "0a948a068f5d4d8b9cc45df90b58d382";
           
            var encrypted = CryptoJS.AES.encrypt(password,
            		CryptoJS.enc.Hex.parse(key), {
                        iv : CryptoJS.enc.Hex.parse(iv),
                        mode : CryptoJS.mode.CBC,
                        padding : CryptoJS.pad.Pkcs7
                    });
            var encryptedInHex = encrypted.ciphertext
                    .toString(CryptoJS.enc.Hex); // converting the encrypted
													// data in Hexadecimal
            var hash=encryptedInHex.toUpperCase();
        	return hash;
        }

        $rootScope.home=false;
        $rootScope.bm=false;
        $rootScope.qst=false;
        $rootScope.score=false;
        $rootScope.fsm=false;
        $rootScope.sme=false;

    }
})();
